import { c as _c } from "react/compiler-runtime";
import { renderArtifactBlock } from '@/features/investigation';
import { REPORT_EXAMPLES } from './report-examples';
import type { ReportSectionKind } from './report-outline';
const noop = () => {};

// Kept short: the example repeats under every narrative section, and a long one drowns the outline.
const PROSE = ['Alert AL-88213 flagged 47 credits totalling $312,450 over three weeks, against a stated payroll baseline of $4,000 a month.', 'The disposition is to file a SAR, routed for human review.'];
type SectionExampleProps = {
  /** A custom section follows its own instructions, so it has no shape to show. */
  kind: Exclude<ReportSectionKind, 'custom'>;
  /** Only prose shows it: a block carries its own title. */
  heading?: string;
};
const SectionExample = t0 => {
  const $ = _c(3);
  const {
    kind,
    heading
  } = t0;
  let t1;
  if ($[0] !== heading || $[1] !== kind) {
    t1 = kind === "narrative" ? <div className="flex flex-col">{heading && <p className="pb-1.5 font-bold text-[21px] text-primary leading-[1.3]">{heading}</p>}{PROSE.map(_temp)}</div> : renderArtifactBlock(kind, JSON.stringify(REPORT_EXAMPLES[kind]), {
      editable: false,
      onChange: noop,
      onDelete: noop
    });
    $[0] = heading;
    $[1] = kind;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SectionExample;
function _temp(paragraph) {
  return <p className="py-[9px] text-body-2 text-primary leading-[1.6] first:pt-0 last:pb-0" key={paragraph}>{paragraph}</p>;
}